import { Injectable } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs'
import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root',
})
export class PageViewTrackerService extends ApiService {
  constructor(private router: Router) {
    super()
  }

  /**
   * Start tracking page views and call the API on every route change
   */
  startTracking(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.trackPageView(event.url)
      })
  }

  /**
   * Call the page view count API
   * @param url The current URL that was navigated to
   */
  private trackPageView(url: string): void {
    // Call the API endpoint to track page view
    this.post('/user/page-view-count', { url }).subscribe({
      next: (response) => {
        console.log('Page view tracked successfully:', response)
      },
      error: (error) => {
        console.error('Failed to track page view:', error)
      },
    })
  }
}
